import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api'

export interface UserLocation {
  _id: string
  userId: string
  latitude: number
  longitude: number
  accuracy?: number
  timestamp: string
  activity?: string
  speed?: number
  heading?: number
}

/**
 * Get user locations
 * @param userId - User ID
 * @param startDate - Optional start date filter
 * @param endDate - Optional end date filter
 * @returns Promise with user locations
 */
export async function getUserLocations(
  userId: string,
  startDate?: string,
  endDate?: string
): Promise<{ data: UserLocation[] }> {
  const token = localStorage.getItem('auth_token')
  const params: any = {}
  
  if (startDate) params.startDate = startDate
  if (endDate) params.endDate = endDate
  
  console.log('Fetching locations for userId:', userId)
  console.log('Using token:', token ? token.substring(0, 20) + '...' : 'NO TOKEN')
  
  const response = await axios.get(`${API_URL}/locations/${userId}`, {
    headers: { Authorization: `Bearer ${token}` },
    params,
  })
  
  console.log('Locations response:', response.data?.length || 0, 'points')
  return { data: response.data }
}
